import { FC } from 'react';
import { Badge, Typography } from '../../../ui';
import { Divider } from '../../../atoms/divider/divider';

type Props = {
  initials: string;
  name: string;
  src?: string;
  alt?: string;
  date: string;
};

export const ChangedAssigneeDivider: FC<Props> = (props) => {
  const { initials, src, alt, date, name } = props;

  return (
    <Divider>
      <div className="flex items-center space-x-8">
        <Typography
          variant="body-xs"
          weight="regular"
          className="text-grayscale400 text-nowrap"
        >
          Toegewezen aan
        </Typography>
        <Badge avatar={{ initials, src, alt }} label={name} />
        <Typography
          variant="body-xxs"
          weight="regular"
          className="text-grayscale300 text-nowrap"
        >
          {date}
        </Typography>
      </div>
    </Divider>
  );
};
